// Settings state selectors

export const navStyleSelector = (state) => state.getIn(['settings', 'navStyle']);

export const navCollapsedSelector = (state) => state.getIn(['settings', 'navCollapsed']);

export const widthSelector = (state) => state.getIn(['settings', 'width']);

export const pathnameSelector = (state) => state.getIn(['settings', 'pathname']);

export const loaderSelector = (state) => state.getIn(['settings', 'loader']);

export const getAppError = (state) => state.getIn(['settings', 'appError']);

export const getIsAppReady = (state) => state.getIn(['settings', 'isAppReady']);

// Get Settings by key
export const getSettingByKey = (state, { settingKey }) =>
  state.getIn(['settings', 'userState', ...settingKey.split('.')]);

// Get setting filters by key
export const getFiltersByKey = (state, { settingKey, filterParam, customFilters = {} }) => {
  let filters = state.getIn(['settings', 'userState', settingKey, 'filters']);
  if (filters) {
    if (filterParam) {
      const { key, value } = filterParam;
      if (filters.get(key) !== value) {
        return null;
      }
    }
    if (customFilters) {
      Object.keys(customFilters).forEach((key) => {
        filters = filters.set(key, customFilters[key]);
      });
    }
  }
  return filters;
};

// Get setting sorting by key
export const getSortingByKey = (state, { settingKey }) =>
  state.getIn(['settings', 'userState', ...settingKey.split('.'), 'sorting']);

// Get setting article font size
export const getArticleFontSize = (state) => state.getIn(['settings', 'userState', 'articlePage', 'fontSize']);

// Get search
export const getSearch = (state) => state.getIn(['settings', 'search']);

// Get show applause
export const getShowApplause = (state) => state.getIn(['settings', 'showApplause']);

// Get pagination setting by key
export const getPaginationSettingsByKey = (state, { settingKey }) =>
  state.getIn(['settings', 'userState', settingKey, 'pageSize']);

// Get count moderate entities
export const getModerateEntitiesCount = (state) => state.getIn(['settings', 'moderateCount']);
